(function() {
    let sizes = window.condom_sizes.widths;

    window['choose_your_size'] = {
        init: function(callback, container, width_callback) {
            if (typeof container === 'undefined') {
                container = $(document);
            }
            var width_codes = container.find('.width-code');
            var length_codes = container.find('.length-code');
            length_codes.hide();
            $.each(sizes, function(key, val) {
                width_codes.append(
                    '<div id="width' + key + '" data-code="' + key + '" style="display:none">' + key + '</div>'
                ).find('div#width' + key).fadeIn('slow');
            });

            width_codes.on('click', 'div', function(e) {
                e.preventDefault();
                width_codes.find('div.active').removeClass('active');
                var width = $(this);

                var width_code = width.data('code');
                width.addClass('active');

                var save = length_codes.find('p').detach();
                length_codes.empty().append(save);
                length_codes.fadeIn('slow');
                $.each(sizes[width_code], function(key, dat) {
                    length_codes.append(
                        '<div id="length' + dat.lengthCode + '" data-code="' + dat.lengthCode + '" style="display:none">' + dat.lengthCode + '</div>'
                    ).find('div#length' + dat.lengthCode).fadeIn(3000);
                });

                if (typeof width_callback !== 'undefined') {
                    width_callback(width_code, width);
                }
            });

            length_codes.on("click", 'div', function(e) {
                e.preventDefault();
                var length = $(this);
                var dat = sizes[width_codes.find('div.active').data('code')][length.data('code')];
                console.log(dat);
                callback(dat.code, length, container);
            });
        }
    };
})();
